import * as yup from "yup";
import { getStringRequiredFieldMessage } from "@shared/utils/yup-extensions";

export const subscriptionCheckoutFormSchema = yup
  .object()
  .shape({
    addressLine1: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("Address"),
    addressLine2: yup.string().trim().optional().label("Address line 2"),
    addressCity: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("City"),
    addressState: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("State"),
    addressCountry: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("Country"),
    addressZipCode: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("Postal code"),
  })
  .required();

export type SubscriptionCheckoutFormSchema =
  typeof subscriptionCheckoutFormSchema.__outputType;
